import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Footer.module.scss';

const FindWork = ({ omitHeading = false }) => {
  return (
    <ul className={styles.linkList}>
      {!omitHeading && (
        <li>
          <a href="/jobs">Find work</a>
        </li>
      )}
      <li>
        <a href="/freelance/ari">Ari, your job assistant</a>
      </li>
      <li>
        <a href="/freelancers">How to find work</a>
      </li>
      <li>
        <a href="/freelance/creatives">Find creative jobs</a>
      </li>
      <li>
        <a href="/freelance/developers">Find developer jobs</a>
      </li>
      <li>
        <a href="/freelance/marketing">Find marketing jobs</a>
      </li>
      <li>
        <a href="/jobs">See all freelance jobs</a>
      </li>
    </ul>
  );
};

FindWork.propTypes = {
  omitHeading: PropTypes.bool,
};

export default FindWork;
